import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import {
  getAllReportPlayer,
  getPlayerSubscription,
  getSession,
  getStatus,
} from "../../../services/academicService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import DatePicker from "react-datepicker";
import {
  getPublicAgeCategory,
  getPublicDueTypeList,
  getPublicPaymentStatus,
} from "../../../services/publicService";
import DuesPaymentModal from "../../components/reports/DuesPaymentModal";
import {
  getOverdueRangeReport,
  getOverDueReport,
} from "../../../services/ReportService";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Player Id", sortingVale: "id" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Age", sortingVale: "age" },
  { heading: "Gender", sortingVale: "gender" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Mobile", sortingVale: "mobile" },
  { heading: "Package", sortingVale: "package" },
  { heading: "Due Amount", sortingVale: "dueAmount" },
  { heading: "Due Date", sortingVale: "dueDate" },
];

const NoRenewalReports = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);

  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [qrCodeModal, setQrCodeModal] = useState(false);
  const [currentStart, setCurrentStart] = useState(0);
  const [paymentModal, setPaymentModal] = useState(false);
  //filter
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [dueList, setDueList] = useState([]);
  const [ageCategory, setAgeCategory] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageData, setPackageData] = useState([]);
  const [open, setOpen] = useState(true);
  //palyer dropdown
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [userTenant, setUserTenant] = useState(null);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0); // 0-based
  const [tenantSearch, setTenantSearch] = useState("");
  const pageSize = 20;
  const [overdueRange, setOverdueRange] = useState([]);
  const [selectedOverdueRange, setSelectedOverdueRange] = useState(null);
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  const formatDate = (date) => {
    if (!date) return null;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getOverDueReport(
        page,
        size,
        search,
        selectedPlayer?.value || "",
        selectedPackage || "",
        selectedOverdueRange || "",
        formatDate(startDate),
        formatDate(endDate),
      );
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({
      page,
      size,
      search,
      selectedPackage,
      selectedPlayer,
      selectedOverdueRange,
      startDate,
      endDate,
    });
  }, [
    page,
    size,
    search,
    selectedPackage,
    selectedPlayer,
    selectedOverdueRange,
    startDate,
    endDate,
  ]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) => {
          const nameA = a?.player?.name || a?.name || "";
          const nameB = b?.player?.name || b?.name || "";
          return iconData.complete
            ? nameA.localeCompare(nameB)
            : nameB.localeCompare(nameA);
        });
        break;

      case "email":
        sortedPeople.sort((a, b) => {
          const emailA = a?.player?.email || a?.email || "";
          const emailB = b?.player?.email || b?.email || "";
          return iconData.complete
            ? emailA.localeCompare(emailB)
            : emailB.localeCompare(emailA);
        });
        break;

      case "mobile":
      case "phone":
        sortedPeople.sort((a, b) => {
          const phoneA = a?.player?.phone || a?.phone || "";
          const phoneB = b?.player?.phone || b?.phone || "";
          return iconData.complete
            ? phoneA.localeCompare(phoneB)
            : phoneB.localeCompare(phoneA);
        });
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  const downloadExcel = async () => {
    try {
      const res = await getOverDueReport(
        0,
        10000,
        search,
        selectedPlayer?.value || "",
        selectedPackage || "",
        selectedOverdueRange || "",
        formatDate(startDate),
        formatDate(endDate),
      );

      const formattedData = res?.content?.map((data, index) => ({
        "S.No": index + 1,
        "Player Id": data?.player?.serialNumber || "-",
        Name: data?.player?.name || "-",
        Age: data?.player?.age || "-",
        Gender: data?.player?.sex || "-",
        Email: data?.player?.email || "-",
        Mobile: data?.player?.phone || "-",
        Package: data?.player?.subscription?.packageType?.name || "-",
        "Due Amount": data?.dueAmount ?? "-",
        "Due Date": data?.dueDate || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData || []);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "No Renewal Reports");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "no_renewal_reports.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  useEffect(() => {
    fetchDueList();
    fetchPaymentStatus();
    fetchAgeCategory();
    fetchOverdueRange();
  }, []);

  async function fetchDueList() {
    try {
      const res = await getPlayerSubscription();
      setPackageData(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchPaymentStatus() {
    try {
      const res = await getPublicPaymentStatus();
      setPaymentStatus(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchAgeCategory() {
    try {
      const res = await getPublicAgeCategory();
      setAgeCategory(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchOverdueRange() {
    try {
      const res = await getOverdueRangeReport();
      setOverdueRange(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  const loadTenants = async (pageToLoad = 0, search = "") => {
    if (isLoading) return;

    try {
      setIsLoading(true);

      const data = await getAllReportPlayer(pageToLoad, pageSize, search);

      const newOptions = data.content.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      if (pageToLoad === 0) {
        setTenantOptions(newOptions);
      } else {
        setTenantOptions((prev) => [...prev, ...newOptions]);
      }

      setPages(pageToLoad);
      setHasMore(!data.last);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTenants();
  }, []);

  return (
    <>
      <PageTitle activeMenu={"No Renewal Reports"} motherMenu={"Reports"} />
      <div className="filter cm-content-box box-primary">
        <div className={`content-title`} onClick={() => setOpen(!open)}>
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
            >
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-3">
                  <label className="form-label">Select Player</label>
                  <Select
                    value={selectedPlayer}
                    options={tenantOptions}
                    onChange={setSelectedPlayer}
                    isClearable
                    isLoading={isLoading}
                    filterOption={null} // Disable frontend filtering
                    onInputChange={(value, actionMeta) => {
                      if (actionMeta.action === "input-change") {
                        setTenantSearch(value);
                        setHasMore(true);
                        loadTenants(0, value); // Backend search
                      }
                    }}
                    onMenuScrollToBottom={() => {
                      if (hasMore && !isLoading) {
                        loadTenants(pages + 1, tenantSearch);
                      }
                    }}
                  />
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 mb-3">
                  <label className="form-label d-block text-start mb-1">Package</label>
                  <Select
                    isSearchable={false}
                    options={[
                      { value: "", label: "Select Package" },
                      ...(Array.isArray(packageData) ? packageData : []).map(
                        (pkg) => ({
                          value: pkg?.id,
                          label: `${pkg?.packageType?.name || pkg?.name || ""}`,
                        }),
                      ),
                    ]}
                    className="custom-react-select"
                    onChange={(e) => setSelectedPackage(e?.value || "")}
                    placeholder="Select Package"
                  />
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 mb-3">
                  <label className="form-label d-block text-start mb-1">Overdue Range</label>
                  <Select
                    isSearchable={false}
                    options={[
                      { value: "", label: "Select Overdue Range" },
                      ...(Array.isArray(overdueRange) ? overdueRange : []).map(
                        (range) => ({
                          value: range?.key,
                          label: `${range?.label}`,
                        }),
                      ),
                    ]}
                    className="custom-react-select"
                    onChange={(e) => setSelectedOverdueRange(e?.value || "")}
                    placeholder="Select Overdue Range"
                  />
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 mb-3">
                  <label className="form-label d-block text-start mb-1">Start Date</label>
                  <div className="w-100 d-block">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        setEndDate(null); // reset end date
                      }}
                      maxDate={new Date()}
                      dateFormat="yyyy-MM-dd"
                      className="form-control w-100"
                      wrapperClassName="d-block w-100"
                      placeholderText="Select start date"
                    />
                  </div>
                </div>

                <div className="col-xl-3 col-md-4 col-sm-6 col-12 mb-3">
                  <label className="form-label d-block text-start mb-1">End Date</label>
                  <div className="w-100 d-block">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      minDate={startDate}
                      maxDate={
                        startDate
                          ? new Date(
                            new Date(startDate).setDate(
                              startDate.getDate() + 90,
                            ),
                          )
                          : new Date()
                      }
                      disabled={!startDate}
                      dateFormat="yyyy-MM-dd"
                      className="form-control w-100"
                      wrapperClassName="d-block w-100"
                      placeholderText="Select end date"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 d-flex align-items-end mb-3">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    style={{ height: "2.8rem" }}
                    onClick={downloadExcel}
                  >
                    <i className="fas fa-file-excel me-2"></i> Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder=""
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{currentStart * size + ind + 1}</td>
                                  <td>{data?.player?.serialNumber}</td>
                                  <td>{data?.player?.name}</td>
                                  <td>{data?.player?.age}</td>
                                  <td>{data?.player?.sex}</td>
                                  <td>{data?.player?.email}</td>
                                  <td>{data?.player?.phone}</td>
                                  <td>
                                    {
                                      data?.player?.subscription?.packageType
                                        ?.name
                                    }
                                  </td>
                                  <td>{data?.dueAmount}</td>
                                  <td>{data?.dueDate}</td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${page === 0 ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${page + 1 >= totalPages ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
      <DuesPaymentModal
        show={paymentModal}
        onClose={() => setPaymentModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setPaymentModal(false);
          fetchUserData({ page, size, search });
        }}
      />
    </>
  );
};

export default NoRenewalReports;
